// Shared client-search matcher - originally lived only inside Clients.jsx.
// Extracted so the same "does this client match this search" rule can be
// reused (e.g. the quick-jump search on ClientDetail.jsx) without two copies
// silently drifting apart on which fields count or how phone digits match.
//
// Matches on business name, owner name, DBA, either email field, the client
// code/id, or (once at least 4 digits are typed) either phone field compared
// digit-only so formatting differences never matter.
export function matchesClientSearch(c, q) {
  const needle = String(q || '').trim().toLowerCase();
  if (!needle) return true;
  const fields = [c.businessName, c.ownerName, c.dba, c.email, c.businessEmail, c.clientCode, c.clientId];
  if (fields.some(f => f && String(f).toLowerCase().includes(needle))) return true;
  const digits = needle.replace(/\D/g, '');
  if (digits.length >= 4) {
    return [c.phone, c.ownerPhone].some(p => p && String(p).replace(/\D/g, '').includes(digits));
  }
  return false;
}
